import { CSS } from '../../../const';
import { CellElementType } from '../../../enums';

export class BaseCellElement {
	private size: string;
	private css: KnockoutComputed<string>;
	private cellElementType: CellElementType;
	private template: KnockoutObservable<string>;
	constructor(
		size: string,
		cellElementType: CellElementType,
		editable: KnockoutObservable<boolean>,
		template: string
	) {
		this.template = ko.observable<string>(template);
		this.size = size;
		this.cellElementType = cellElementType;
		this.css = ko.pureComputed(() => {
			var _editable = editable(),
				cssDisabled = '';
			if (!_editable) {
				cssDisabled = CSS.Disabled;
			}
			return CellElementType[this.cellElementType]
				.toLowerCase()
				.concat(' ', CSS.CellX.concat(this.size))
				.concat(' ', cssDisabled);
		});
	}
}
